const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/globalauth/api-factory');
const serviceFactory = require('../resources/globalauth/service-factory');
const messages = require('../utils/constants');
const { Base64 } = require('js-base64');
const falcorVersions = require('../appversion');
const compareVersions = require('../version-checker');

function versionUpdateResponse(inputParam) {
  const params = inputParam.split('#@#');
  const appVersion = Base64.decode(params[0]);
  const platform = params[1];
  const falcorVersion = platform === 'ios' ? falcorVersions.appversioniOS : falcorVersions.appversionAndroid;
  let appUpdateRequireRes = false;

  if (compareVersions(appVersion, falcorVersion) < 0) {
    appUpdateRequireRes = true;
  }

  let oReturn = {
    appUpdateRequire: appUpdateRequireRes
      }
  return JSON.stringify(oReturn);
   
}

function versionUpdateResponseForLUX(inputParam) {
  const params = inputParam.split('#@#');
  const appVersion = Base64.decode(params[0]);
  const platform = params[1];
  const falcorVersion = platform === 'ios'?falcorVersions.appversioniOS: falcorVersions.appversionAndroid;
  let appUpdateRequireRes = false;

  if (compareVersions(appVersion, falcorVersion) < 0) {
    appUpdateRequireRes= true;
  }

  let oReturn = {
    appUpdateRequire: appUpdateRequireRes
      }
  return JSON.stringify(oReturn);
   
}

function parseJson(obj) {
  return JSON.stringify(obj);
}

function forceUpdateMessage() {
  let oReturn = {
    encryptionKeySuccess: false,
    encryptionMSG: messages["update-application-message"]
  }
  return JSON.stringify(oReturn);
}

function forceUpdateMessageGlobal() {
  let oReturn = {
    sessionId: "",
    authHeader: "",
    authSuccess: false,
    passwordExpired: "",
    lastSession: "",
    message: messages["update-application-message"],
    userGroup: ""
  }
  return JSON.stringify(oReturn);
}

function clearsession() {
  let oReturn = {
    message: "success",

  }
  return JSON.stringify(oReturn);
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/globalauth/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
      
    .match(`${p}auth.globalAuthEncryptionJson[{keys:ran_str}][{keys:userId}][{keys:type}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getGlobalAuthEncryptionKey(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}auth.globalAuthEncryptionJsonForLUX[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getGlobalAuthEncryptionKeyForLUX(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}auth.globalAuthLoginVascoNewUI[{keys:userId}][{keys:password}][{keys:dummySesKey}][{keys:token}][{keys:cryptoPass}][{keys:deviceInfo}][{keys:regionCode}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getGlobalAuthentication(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}auth.globalAuthLoginAirLock[{keys:userId}][{keys:password}][{keys:dummySesKey}][{keys:token}][{keys:cryptoPass}][{keys:deviceInfo}][{keys:regionCode}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.getGlobalAuthenticationAirlock(req.params)
            .then(parseJson)
            .then(response => res.value(response))
            .catch(res.error)
    )))
    .match(`${p}auth.globalAuthLoginVascoNewUIForLUX[{keys:inputParam}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getGlobalAuthenticationForLUX(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))


    .match(`${p}auth.glblAuthEBankchangePassword[{keys:userId}][{keys:encryptedPassword}][{keys:oldEncryptedPassword}][{keys:oldCryptoPassword}][{keys:newCryptoPassword}][{keys:token}][{keys:dummySesKey}][{keys:regionCode}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.globalAuthChangeProfilePassword(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}auth.glblAuthEBankchangePasswordForLux[{keys:userId}][{keys:encryptedPassword}][{keys:oldEncryptedPassword}][{keys:oldCryptoPassword}][{keys:newCryptoPassword}][{keys:token}][{keys:dummySesKey}][{keys:regionCode}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.globalAuthChangeProfilePasswordForLux(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}auth.glblAuthEBankclearOtherSession[{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) => res.value(clearsession(req.params))
      )))

    .match((`${p}auth.initiateResetPin[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.initiateResetPin(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match((`${p}auth.generateAuthCodeForECred[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.generateAuthCodeForECred(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match((`${p}auth.validateECredAuthCode[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.validateECredAuthCode(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match((`${p}auth.updateECredStatus[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.updateECredStatus(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match((`${p}auth.initiateResetPassword[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.initiateResetPassword(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match((`${p}auth.generateTempPassword[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.generateTempPassword(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match(`${p}auth.logout[{keys:channelInfo}][{keys:logoutDsc}]`, requests => Promise.all(
        requests.map(({ req, res }) =>
          service.logout(req.params)
            .then(response => res.value(response.logoutSuccess))
            .catch(res.error)
      )))
    .match((`${p}auth.updatePassword[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
      requests.map(({ req, res }) =>
        service.updatePassword(req.params)
          .then(parseJson)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match((`${p}auth.initiateChangePassword[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
        requests.map(({ req, res }) =>
          service.initiateChangePassword(req.params)
          .then(response => res.value(response))
          .catch(res.error)
    )))
}

module.exports = addRoutes;
